var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultCoachThumbnail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53 53",
    width: 53,
    height: 53,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_default_thumbnail-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #e4efff } \n\t\t.s1 { fill: #ffffff } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uBAA8\\uC591 1",
    className: "s0",
    d: "m0 0h53v53h-53z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m26.6 13.3c4.5 0 7.8 3.3 7.8 7.8c0 4.5-3.3 7.8-7.8 7.8c-4.5 0-7.8-3.3-7.8-7.8c0-4.5 3.3-7.8 7.8-7.8zm-13.3 25.4c2.3-3.4 6.2-5.7 10.7-5.7h5.2c4.4 0 8.3 2.3 10.6 5.7c-3.3 3.5-8 5.8-13.2 5.8c-5.3 0-10-2.3-13.3-5.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultCoachThumbnail);
export default __webpack_public_path__ + "static/media/default_coach_thumbnail.bad9cbdaccb69b6f01a0be823059c2cf.svg";
export { ForwardRef as ReactComponent };